// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__2YDYQ","tabs":"LayoutWrapperSideNav_tabs__3i3F_","tab":"LayoutWrapperSideNav_tab__3GMb4"};